import { render, staticRenderFns } from "./Scene21.vue?vue&type=template&id=7ca9ec78&scoped=true"
import script from "./Scene21.vue?vue&type=script&lang=js"
export * from "./Scene21.vue?vue&type=script&lang=js"
import style0 from "./Scene21.vue?vue&type=style&index=0&id=7ca9ec78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca9ec78",
  null
  
)

export default component.exports